import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const LIQUID_BOTTLE_TAKE_HAS_ERRORED = "LIQUID_BOTTLE_TAKE_HAS_ERRORED";
export const LIQUID_BOTTLE_TAKE_SUCCESS = "LIQUID_BOTTLE_TAKE_SUCCESS";
export const LIQUID_BOTTLE_RELEASE_HAS_ERRORED =
	"LIQUID_BOTTLE_RELEASE_HAS_ERRORED";
export const LIQUID_BOTTLE_RELEASE_SUCCESS = "LIQUID_BOTTLE_RELEASE_SUCCESS";

export const LIQUID_BOTTLE_HAS_ERRORED = "LIQUID_BOTTLE_HAS_ERRORED";
export const LIQUID_BOTTLE_FETCH_DATA_SUCCESS =
	"LIQUID_BOTTLE_FETCH_DATA_SUCCESS";
export const CLEAR_LIQUID_BOTTLE = "CLEAR_LIQUID_BOTTLE";

export const SET_MY_LIQUID_BOTTLES = "SET_MY_LIQUID_BOTTLES";
export const GET_LIQUID_BOTTLE_ASSIGNED_TO_ME =
	"GET_LIQUID_BOTTLE_ASSIGNED_TO_ME";
